require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./button"), require("./constants"), require("./container"), require("./contextmenu"), require("./progressindicator"), require("./svgicon"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./button", "./constants", "./container", "./contextmenu", "./progressindicator", "./svgicon", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./button"), require("./constants"), require("./container"), require("./contextmenu"), require("./progressindicator"), require("./svgicon"), require("./utils")) : factory(root["./button"], root["./constants"], root["./container"], root["./contextmenu"], root["./progressindicator"], root["./svgicon"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__32477__, __WEBPACK_EXTERNAL_MODULE__5210__, __WEBPACK_EXTERNAL_MODULE__32299__, __WEBPACK_EXTERNAL_MODULE__66740__, __WEBPACK_EXTERNAL_MODULE__3142__, __WEBPACK_EXTERNAL_MODULE__56685__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[2193],{

/***/ 81919:
/***/ ((module) => {

var amdi18n={"__root":{"ascending":"Ascending","descending":"Descending","noSort":"No sort"},"__cs":{"ascending":"Vzestupně","descending":"Sestupně","noSort":"Bez řazení"},"__da":{"ascending":"Stigende","descending":"Faldende","noSort":"Ingen sortering"},"__de":{"ascending":"Aufsteigend","descending":"Absteigend","noSort":"Nicht sortieren"},"__es":{"ascending":"Ascendente","descending":"Descendente","noSort":"Sin orden"},"__fi":{"ascending":"Nouseva","descending":"Laskeva","noSort":"Ei lajittelua"},"__fr":{"ascending":"Croissant","descending":"Décroissant","noSort":"Aucun tri"},"__hr":{"ascending":"Uzlazno","descending":"Silazno","noSort":"Ne sortiraj"},"__hu":{"ascending":"Növekvő","descending":"Csökkenő","noSort":"Nincs rendezés"},"__it":{"ascending":"Crescente","descending":"Discendente","noSort":"Nessun ordinamento"},"__ja":{"ascending":"昇順","descending":"降順","noSort":"ソートなし"},"__kk":{"ascending":"Артуы бойынша","descending":"Кемуі бойынша","noSort":"Сұрыптамау"},"__ko":{"ascending":"오름차순","descending":"내림차순","noSort":"정렬 안 함"},"__nb":{"ascending":"Stigende","descending":"Synkende","noSort":"Ingen sortering"},"__nl":{"ascending":"Oplopend","descending":"Aflopend","noSort":"Niet sorteren"},"__no":{"ascending":"Stigende","descending":"Synkende","noSort":"Ingen sortering"},"__pl":{"ascending":"Rosnąco","descending":"Malejąco","noSort":"Bez sortowania"},"__pt":{"ascending":"Ordem crescente","descending":"Ordem decrescente","noSort":"Sem ordenação"},"__pt-br":{"ascending":"Ordem crescente","descending":"Ordem decrescente","noSort":"Sem ordenação"},"__ro":{"ascending":"Crescător","descending":"Descrescător","noSort":"Fără sortare"},"__ru":{"ascending":"По восходящей","descending":"По нисходящей","noSort":"Без сортировки"},"__sl":{"ascending":"Naraščajoče","descending":"Padajoče","noSort":"Brez razvrščanja"},"__sv":{"ascending":"Stigande","descending":"Fallande","noSort":"Ingen sortering"},"__th":{"ascending":"น้อยไปหามาก","descending":"จากมากไปหาน้อย","noSort":"ไม่เรียงลำดับ"},"__tr":{"ascending":"Artan","descending":"Azalan","noSort":"Sıralama yok"},"__zh":{"ascending":"升序","descending":"降序","noSort":"不排序"},"__zh-cn":{"ascending":"升序","descending":"降序","noSort":"不排序"},"__zh-hk":{"ascending":"遞增","descending":"遞減","noSort":"不排序"},"__zh-mo":{"ascending":"遞增","descending":"遞減","noSort":"不排序"},"__zh-sg":{"ascending":"升序","descending":"降序","noSort":"不排序"},"__zh-tw":{"ascending":"遞增","descending":"遞減","noSort":"不排序"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 46088:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports.GridCell = GridCell;
exports.GridHeaderCell = GridHeaderCell;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _react = _interopRequireDefault(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _utils = __webpack_require__(78815);
var _GridCell = _interopRequireDefault(__webpack_require__(26347));
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

const gridHeaderCellClassName = _GridCell.default.gridHeaderCellClassName.replace(/"/g, '');
const gridCellClassName = _GridCell.default.gridCellClassName.replace(/"/g, '');
const onKeyDown = (e, clickHandler) => {
  if (e.keyCode === 32 || e.keyCode === 13) {
    clickHandler && clickHandler();
  }
};
function GridCell(_ref) {
  let {
    children,
    className,
    style,
    onClick,
    dir,
    verticalBorder,
    horizontalBorder,
    ...others
  } = _ref;
  let borderClassName = verticalBorder && (dir === 'rtl' ? {
    'rtl-border': true
  } : {
    'ltr-border': true
  });
  borderClassName = (0, _utils.classnames)(borderClassName, {
    horizontalBorder
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, others, {
    onKeyDown: e => onKeyDown(e, onClick),
    onClick: onClick,
    className: (0, _utils.classnames)(gridCellClassName, className, borderClassName),
    style: style
  }), children);
}
GridCell.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  verticalBorder: _propTypes.default.bool,
  horizontalBorder: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  style: _propTypes.default.object,
  dir: _propTypes.default.string
};
GridCell.defaultProps = {
  verticalBorder: true,
  horizontalBorder: true
};
function GridHeaderCell(_ref2) {
  let {
    children,
    className,
    style,
    dir,
    onClick,
    onContextMenu,
    verticalBorder,
    horizontalBorder,
    ...others
  } = _ref2;
  let borderClassName = verticalBorder && (dir === 'rtl' ? {
    'rtl-border': true
  } : {
    'ltr-border': true
  });
  borderClassName = (0, _utils.classnames)(borderClassName, {
    horizontalBorder
  });
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, others, {
    onClick: onClick,
    onKeyDown: e => onKeyDown(e, onClick),
    onContextMenu: onContextMenu,
    className: (0, _utils.classnames)(gridHeaderCellClassName, className, borderClassName),
    style: style
  }), children);
}
GridHeaderCell.propTypes = {
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  verticalBorder: _propTypes.default.bool,
  horizontalBorder: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  onContextMenu: _propTypes.default.func,
  style: _propTypes.default.object,
  dir: _propTypes.default.string
};
GridHeaderCell.defaultProps = {
  verticalBorder: true,
  horizontalBorder: true
};

/***/ }),

/***/ 68607:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _reactDom = _interopRequireDefault(__webpack_require__(66405));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _button = _interopRequireDefault(__webpack_require__(32477));
var _svgicon = _interopRequireDefault(__webpack_require__(56685));
var _utils = __webpack_require__(78815);
var _container = _interopRequireDefault(__webpack_require__(32299));
var _contextmenu = _interopRequireDefault(__webpack_require__(66740));
var _constants = __webpack_require__(5210);
var _arrowsVertical_ = _interopRequireDefault(__webpack_require__(75924));
var _arrowDown_ = _interopRequireDefault(__webpack_require__(15809));
var _arrowUp_ = _interopRequireDefault(__webpack_require__(6218));
var _progressindicator = _interopRequireDefault(__webpack_require__(3142));
var _GridSortCell = _interopRequireDefault(__webpack_require__(30165));
var _StringResource = _interopRequireDefault(__webpack_require__(67017));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

// TODO Add NLS
// import { getString } from '../../nls/StringResources';
const gridClassName = _GridSortCell.default.gridClassName.replace(/"/g, '');
function getString(value) {
  return _StringResource.default.get(value);
}
const {
  sanitize
} = _utils.propsUtils;
const {
  DESC,
  ASC,
  NO_SORT
} = _constants.sortTypes;
const MENU_NAME = 'gridSortCellMenu';
class GridSortCell extends _react.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "state", {
      open: false
    });
    (0, _defineProperty2.default)(this, "menuContent", [{
      id: 'iasc',
      label: this.props.getLocaleString('ascending'),
      value: ASC
    }, {
      id: 'idsc',
      label: this.props.getLocaleString('descending'),
      value: DESC
    }, {
      id: 'insrt',
      label: this.props.getLocaleString('noSort'),
      value: NO_SORT
    }]);
    (0, _defineProperty2.default)(this, "_onSelectionChange", (name, sortType) => {
      const {
        onSortChange
      } = this.props;
      this._toggleContextMenu(false);
      onSortChange && onSortChange(sortType);
    });
    (0, _defineProperty2.default)(this, "_sortBtnRef", r => {
      this._sortBtn = _reactDom.default.findDOMNode(r);
    });
    (0, _defineProperty2.default)(this, "_toggleContextMenu", (e, open) => {
      e && e.stopPropagation();
      const {
        onSortMenu
      } = this.props;
      this.setState({
        open
      });
      open && onSortMenu && onSortMenu();
    });
  }
  _setSortIcon() {
    const {
      sortType
    } = this.props;
    if (sortType === DESC) {
      return _arrowDown_.default.id;
    }
    if (sortType === ASC) {
      return _arrowUp_.default.id;
    }
    return _arrowsVertical_.default.id;
  }
  _getSortKey() {
    const {
      sortType
    } = this.props;
    let sortKey;
    switch (sortType) {
      case '':
        sortKey = 'noSort';
        break;
      case 'asc':
        sortKey = 'ascending';
        break;
      case 'desc':
        sortKey = 'descending';
        break;
      default:
        sortKey = '';
    }
    return sortKey;
  }
  _isSortingUnderway() {
    const {
      isSorting,
      sortedCol,
      col
    } = this.props;
    if (isSorting && sortedCol === col) {
      return true;
    }
    return false;
  }
  _renderSpinner() {
    return /*#__PURE__*/_react.default.createElement(_progressindicator.default, {
      size: "normal",
      variant: "circle"
    });
  }
  render() {
    const {
      open
    } = this.state;
    const {
      className,
      style,
      priority,
      sortType,
      getLocaleString,
      isSorting,
      label,
      labelIcon,
      ...others
    } = this.props;
    const classNames = (0, _utils.classnames)(`${gridClassName}__sort-cell`);
    const sortTitle = this._getSortKey();
    return /*#__PURE__*/_react.default.createElement(_container.default, (0, _extends2.default)({}, sanitize(others, GridSortCell), {
      className: `${classNames} ${className}`,
      style: style
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: `${gridClassName}__sort-cell-header`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `${gridClassName}__sort-cell-header_label`
    }, label), /*#__PURE__*/_react.default.createElement("div", {
      className: `${gridClassName}__sort-cell-flexdiv`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `${gridClassName}__sort-cell-order-icon`
    }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, labelIcon && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_svgicon.default, {
      pad: true,
      iconId: labelIcon.id,
      size: "small"
    })), !this._isSortingUnderway() && /*#__PURE__*/_react.default.createElement("div", {
      className: `${gridClassName}__sort-cell-priority`
    }, priority === 0 ? '' : priority)), /*#__PURE__*/_react.default.createElement("span", {
      ref: r => {
        this._DOMNodeToAttachTo = r;
      }
    }, this._isSortingUnderway() ? this._renderSpinner() : sortType !== NO_SORT && /*#__PURE__*/_react.default.createElement(_button.default, {
      className: (0, _utils.classnames)(`${gridClassName}__sort-cell-icons`, {
        sort: (sortType == null ? void 0 : sortType.length) > 0
      }),
      icon: this._setSortIcon(),
      size: "small",
      variant: "icon",
      title: getLocaleString(sortTitle),
      ref: this._sortBtnRef,
      onClick: e => this._toggleContextMenu(e, true),
      disabled: isSorting
    })))), open && /*#__PURE__*/_react.default.createElement(_contextmenu.default, {
      placement: "bottomRight",
      triggerNode: this._sortBtn,
      domNodeToAttachTo: document.body,
      onClose: () => this._toggleContextMenu(false),
      onChange: this._onSelectionChange,
      selected: {
        [MENU_NAME]: sortType
      }
    }, /*#__PURE__*/_react.default.createElement(_contextmenu.default.List, {
      content: this.menuContent,
      name: MENU_NAME
    }))));
  }
}
exports["default"] = GridSortCell;
(0, _defineProperty2.default)(GridSortCell, "propTypes", {
  closeSortMenu: _propTypes.default.bool,
  sortType: _propTypes.default.string.isRequired,
  priority: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onSortChange: _propTypes.default.func,
  className: _propTypes.default.string,
  getLocaleString: _propTypes.default.func,
  style: _propTypes.default.object,
  col: _propTypes.default.number,
  isSorting: _propTypes.default.bool,
  sortedCol: _propTypes.default.number,
  onSortMenu: _propTypes.default.func,
  label: _propTypes.default.node,
  labelIcon: _propTypes.default.object
});
(0, _defineProperty2.default)(GridSortCell, "defaultProps", {
  className: '',
  style: {},
  isSorting: false,
  getLocaleString: getString
});

/***/ }),

/***/ 45283:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _GridSortCell = _interopRequireDefault(__webpack_require__(68607));
exports.GridSortCell = _GridSortCell.default;
var _GridCell = __webpack_require__(46088);
exports.GridCell = _GridCell.GridCell;
exports.GridHeaderCell = _GridCell.GridHeaderCell;

/***/ }),

/***/ 67017:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports["default"] = void 0;
var _utils = __webpack_require__(78815);
var _GridAddonsResources = _interopRequireDefault(__webpack_require__(81919));
/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = exports["default"] = new _utils.StringResource(_GridAddonsResources.default);

/***/ }),

/***/ 2222:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-gridHeaderCell.header-cell,.ba-common-gridCell.bottom-right-grid-cell{display:flex;flex-direction:row;align-items:center;outline:0;box-sizing:border-box;font-size:.875rem;word-break:break-word}.ba-common-gridCell.bottom-right-grid-cell{border:none;background-color:#fff}.ba-common-gridCell.bottom-right-grid-cell.cell-is-selected{background-color:#e0e0e0;background-color:hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.8431372549%), 1)}.ba-common-gridCell.bottom-left-grid-cell{background-color:#fff;box-sizing:border-box}.ba-common-gridCell.top-left-grid-cell{background-color:#e0e0e0;background-color:hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.8431372549%), 1)}.ba-common-gridCell.top-right-grid-cell.cell-is-selected{background-color:#e0e0e0;background-color:hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.8431372549%), 1)}.ba-common-gridCell.cell-is-focused{background-color:#e0e0e0;background-color:hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.8431372549%), 1)}.ba-common-gridCell.cell-is-focused::after{content:\"\";position:absolute;border:2px solid;border-color:#0f62fe;border-color:hsla(var(--interactive-01-h, 219.1631799163), var(--interactive-01-s, 99.1701244813%), var(--interactive-01-l, 52.7450980392%), 1);top:0;left:0;right:0;bottom:0;pointer-events:none}.ba-common-gridCell.rtl-border{border-left:1px solid #c0bfc0}.ba-common-gridCell.is-horizontalBorder{border-bottom:1px solid #c0bfc0}.ba-common-gridCell.ltr-border{border-right:1px solid #c0bfc0}.ba-common-gridHeaderCell.header-cell{background-color:#eaeaea;background-color:hsla(var(--gray1-h, 0), var(--gray1-s, 0%), var(--gray1-l, 91.7647058824%), 1);font-weight:bold;cursor:pointer}.ba-common-gridHeaderCell.header-cell.cell-is-selected{border:1px solid;border-color:#0f62fe;border-color:hsla(var(--interactive-01-h, 219.1631799163), var(--interactive-01-s, 99.1701244813%), var(--interactive-01-l, 52.7450980392%), 1);background-color:#c0bfc0;background-color:hsla(var(--gray2-h, 300), var(--gray2-s, 0.7874015748%), var(--gray2-l, 75.0980392157%), 1)}.ba-common-gridHeaderCell.header-cell:hover:not(.cell-is-selected){background-color:#c0bfc0;background-color:hsla(var(--gray2-h, 300), var(--gray2-s, 0.7874015748%), var(--gray2-l, 75.0980392157%), 1)}.ba-common-gridHeaderCell.cell-is-focused::after{content:\"\";position:absolute;border:2px solid;border-color:#0f62fe;border-color:hsla(var(--interactive-01-h, 219.1631799163), var(--interactive-01-s, 99.1701244813%), var(--interactive-01-l, 52.7450980392%), 1);top:0;left:0;right:0;bottom:0;pointer-events:none}.ba-common-gridHeaderCell.rtl-border{border-left:1px solid #c0bfc0}.ba-common-gridHeaderCell.ltr-border{border-right:1px solid #c0bfc0}.ba-common-gridHeaderCell.is-horizontalBorder{border-bottom:1px solid #c0bfc0}.ba-common-gridHeaderCell.cell-is-selected{background-color:#e0e0e0;background-color:hsla(var(--ui-03-h, 0), var(--ui-03-s, 0%), var(--ui-03-l, 87.8431372549%), 1)}", ""]);

// exports
exports.locals = {
	"gridCellClassName": "\"ba-common-gridCell\"",
	"gridHeaderCellClassName": "\"ba-common-gridHeaderCell\""
};

/***/ }),

/***/ 15485:
/***/ ((module, exports, __webpack_require__) => {

exports = module.exports = __webpack_require__(98060)(false);
// imports


// module
exports.push([module.id, ".ba-common-grid__sort-cell{user-select:none;height:100%;width:100%;cursor:pointer}.ba-common-grid__sort-cell-header{display:flex;align-items:center;justify-content:space-between;height:100%;width:100%}.ba-common-grid__sort-cell-header_label{width:100%;white-space:nowrap}.ba-common-grid__sort-cell-flexdiv{display:flex;align-items:center;height:100%;cursor:pointer}.ba-common-grid__sort-cell-order-icon{display:flex;flex-direction:row;flex-shrink:1;align-items:center}.ba-common-grid__sort-cell-order-icon:hover{cursor:pointer}.ba-common-grid__sort-cell-priority{font-size:.875rem;font-weight:600;color:#343334;color:hsla(var(--gray5-h, 300), var(--gray5-s, 0.9708737864%), var(--gray5-l, 20.1960784314%), 1);cursor:pointer;width:max-content}.ba-common-grid__sort-cell-icons.is-sort{color:#343334;color:hsla(var(--gray5-h, 300), var(--gray5-s, 0.9708737864%), var(--gray5-l, 20.1960784314%), 1)}.ba-common-grid__sort-cell-icons:not(.is-sort):hover{color:#343334;color:hsla(var(--gray5-h, 300), var(--gray5-s, 0.9708737864%), var(--gray5-l, 20.1960784314%), 1)}", ""]);

// exports
exports.locals = {
	"gridClassName": "\"ba-common-grid\""
};

/***/ }),

/***/ 26347:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_GridCell_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2222);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_GridCell_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_GridCell_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_GridCell_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_GridCell_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_GridCell_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_GridCell_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_GridCell_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_GridCell_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 30165:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93379);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7795);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90569);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3565);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19216);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44589);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_GridSortCell_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15485);
/* harmony import */ var _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_GridSortCell_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_GridSortCell_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_GridSortCell_scss__WEBPACK_IMPORTED_MODULE_6__) if(__WEBPACK_IMPORT_KEY__ !== "default") __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_GridSortCell_scss__WEBPACK_IMPORTED_MODULE_6__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_GridSortCell_scss__WEBPACK_IMPORTED_MODULE_6___default()), options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_GridSortCell_scss__WEBPACK_IMPORTED_MODULE_6___default()) && (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_GridSortCell_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) ? (_node_modules_css_loader_index_js_node_modules_sass_loader_dist_cjs_js_ruleSet_1_rules_1_use_2_GridSortCell_scss__WEBPACK_IMPORTED_MODULE_6___default().locals) : undefined);


/***/ }),

/***/ 93379:
/***/ ((module) => {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 90569:
/***/ ((module) => {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 19216:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 3565:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 7795:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 44589:
/***/ ((module) => {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ 15809:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/arrow--down_16");

/***/ }),

/***/ 6218:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/arrow--up_16");

/***/ }),

/***/ 75924:
/***/ ((module) => {

"use strict";
module.exports = require("@ba/ba-graphics/dist/icons-js/arrows--vertical_32");

/***/ }),

/***/ 68779:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 98060:
/***/ ((module) => {

"use strict";
module.exports = require("css-loader/lib/css-base");

/***/ }),

/***/ 580:
/***/ ((module) => {

"use strict";
module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 66405:
/***/ ((module) => {

"use strict";
module.exports = require("react-dom");

/***/ }),

/***/ 32477:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__32477__;

/***/ }),

/***/ 5210:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__5210__;

/***/ }),

/***/ 32299:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__32299__;

/***/ }),

/***/ 66740:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__66740__;

/***/ }),

/***/ 3142:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__3142__;

/***/ }),

/***/ 56685:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__56685__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(45283));
/******/ return __webpack_exports__;
/******/ }
]);
});